import {
  ChangeDetectorRef,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  EventEmitter,
  Output,
} from "@angular/core";
import {
  NgbDate,
  NgbCalendar,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "../../../services/userService/user.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { DatePipe } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import * as moment from "moment";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { environment } from "../../../../environments/environment";
import * as XLSX from "xlsx";
import { Subject } from "rxjs";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Sort } from "@angular/material/sort";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-company",
  templateUrl: "./company.component.html",
  styleUrls: ["./company.component.css"],
})
export class CompanyComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("showimport") showimport: any;
  @Output() clearEvent = new EventEmitter<void>();
  displayedColumns: string[] = [
    "CreatedDate",
    "CompanyName",
    "CompanyTypeName",
    "BusinessStreamName",
    "Website",
    "CompanyProfileName",
    "UserName",
    "CountryName",
    "Landline",
    "Status",
    "Action",
  ];
  sortData: any = { column: "CompanyName", direction: "asc" };
  dtOptions: any = {};
  showcompany: any = [];
  comname: any = "";
  submitted = false;
  editUserForm: FormGroup;
  countryListArray: any = [];
  dropdownSettings: any = {};
  dropdownSetting1: any = {};
  dropdownSetting2: any = {};
  dropdownSetting3: any = {};
  dropdownSetting4: any = {};
  dropdownSetting5: any = {};
  dropdownSetting6: any = {};
  dropdownSetting7: any = {};
  dropdownSetting8: any = {};
  CountryList: any = [];
  deleteId: any;
  modalRef: any;
  dropdownCountry: any = {};
  dropdownCountryPre: any = {};
  dropdownState: any = {};
  userListArray: any = [];
  currentPage: any = 0;
  pageSize: any = 10;
  totalSize: any;
  dataSource: any;
  Source: any;
  active: string;
  dropdownCity;
  any = {};
  cityArray: any = [];
  cityList: any = [];
  businessStreamArray: any = [];
  shownameArray: any = [];
  showntypeArray: any = [];
  showcategoryArray: any = [];
  showProfileArray: any = [];
  showAccountArray: any = [];
  showParentArray: any = [];
  status_id: any;
  sta_type: any;
  date_range: any = { startDate: moment, endDate: moment };
  start_date: string;
  end_date: string;
  timezone: any;
  selectedItems = [];
  Status: any;
  downicon: boolean = true;
  upicon: boolean = true;
  columnsort: any;
  shortcountrynam: any = "";
  submitted1 = false;

  //changes for lazy load
  showMoreUserList: boolean = false;
  showMoreLoader: boolean = true;
  ItemPerPages: number;
  TotalRecord: any;
  userSearch: string;
  searchValueString: string;
  appUrl: string;
  sortArraySelect: string = "TotalProjects";
  sortingProperty: string = "";
  ascDesType: string = "Descending";
  SortType: string = "desc";
  totalCount: number;
  proposalUrlStatus: boolean = false;

  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  invalidDates: moment.Moment[] = [
    moment().add(2, "days"),
    moment().add(3, "days"),
    moment().add(5, "days"),
  ];

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some((d) => d.isSame(m, "day"));
  };

  //Date range
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  CompanyId: any;
  showTable: boolean;
  selecteddate_range: any[];
  showstream: any;
  selectedselect_date: any[];
  baseurl: string;
  isExcelFile: boolean;
  inputFile: any;
  keys: string[];
  dataSheet = new Subject();
  data: unknown[];
  CountryName: any;
  shortcountryname: any;
  shortname: any;
  comid: any;
  companyListArray: any;
  err_message: any;
  file: any;
  restoreId: any;
  files: any;
  allowDragover: boolean;
  totalMediaLength: number;
  totalMediaSize: any;
  file_upload_loader: boolean;
  imgURL: any;
  fileUpload: any;
  fileUploadCount: any;
  pasteEvnetStatus: boolean;
  upfile: any;
  permission: any;
  selectedItemsdate: {};
  type: string;
  namesort: string;
  isCollapsed: any;
  isCollapsed1: boolean = false;
  resetPagination: boolean = false;
  registerForm: FormGroup;
  roleId: any;

  //Filters
  showname: any = [];
  showtype: any = [];
  businessStream: any = [];
  showcategory: any = [];
  showstatus: any = [];
  showaccount: any = [];
  showparent: any = [];
  KeyAccounts: any;
  Totalrec: any = 0;
  invalid: any = 0;
  valid: any = 0;
  dataarray: any = [];
  count: number;
  modelref: BsModalRef;
  fileLen: number;
  sampleCompanyExl: string;
  CmpStatus: any;
  arrHeader: any = [];
  StatusForm: FormGroup;

  //Date range in constructor
  constructor(
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private UserService: UserService,
    private datePipe: DatePipe,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private changeDetectorRefs: ChangeDetectorRef
  ) {
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), "d", 10);
  }
  dropdownList5: any = [];
  dropdownSettings5 = {};
  dropdownList6 = [];
  selectedItems6 = [];
  dropdownSettings6 = {};
  Prefix: any = "";
  searchword: any = "";
  prePattern = "^[a-zA-Z0-9]{5,5}";

  ngOnInit(): void {
    this.sampleCompanyExl = environment.import_sample + "Sample_Company.xlsx";
    this.date_range.startDate = "";
    this.date_range.endDate = "";
    this.baseurl = environment.api_url;
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let rId = localStorage.getItem("roleId");
    this.roleId = this.UserService.decryptData(rId);
    this.isCollapsed = false;
    this.resetPagination = false;
    this.selectedtype = [];
    this.selectedname = [];
    this.date_range = [];
    this.selectedBusiness = [];
    this.selectedcategory = [];
    this.selectedprofile = [];
    this.selectedCountry = [];
    this.selectedState = [];
    this.selectedCity = [];
    this.selectedaccount = [];
    this.selectedparent = [];
    this.selectedItems5 = [];

    this.editUserForm = this.formBuilder.group({
      Prefix: ["", [Validators.required, Validators.pattern(this.prePattern)]],
      CountryId: ["", Validators.required],
      shortcountry: [""],
    });

    this.StatusForm = this.formBuilder.group({
      Remark: ["", Validators.required],
    });

    this.dropdownSettings = {
      singleSelection: false,
      text: "Business Stream",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting1 = {
      singleSelection: false,
      text: "Company Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting2 = {
      singleSelection: false,
      text: "Company Type",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting3 = {
      singleSelection: false,
      text: "Category",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting4 = {
      singleSelection: false,
      text: "Company Profile",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting5 = {
      singleSelection: false,
      text: "Account Manager",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting6 = {
      singleSelection: false,
      text: "Parent Company",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownCountry = {
      singleSelection: false,
      text: "Select Country",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownCountryPre = {
      singleSelection: true,
      text: "Select Country",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting7 = {
      singleSelection: false,
      text: "Select State",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting8 = {
      singleSelection: false,
      text: "Select City",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    if (this.roleId == 1 || this.permission.Company_Restore == 1) {
      this.dropdownList5 = [
        { id: 1, itemName: "Active" },
        { id: 2, itemName: "InActive" },
        { id: 3, itemName: "Delete" },
      ];
    } else {
      this.dropdownList5 = [
        { id: 1, itemName: "Active" },
        { id: 2, itemName: "InActive" },
      ];
    }
    this.dropdownSettings5 = {
      text: "Select Status",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: "1",
    };

    this.dropdownList6 = [
      { id: true, itemName: "True" },
      { id: false, itemName: "False" },
    ];
    this.selectedItems6 = [];
    this.dropdownSettings6 = {
      singleSelection: true,
      text: "Key Account",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: "1",
    }; //end

    this.selectedItemsdate = [];

    this.registerForm = this.formBuilder.group({
      CompanyName: [""],
      ParentCompany: [""],
      CompanyTypeId: [""],
      CompanyProfileId: [""],
      StartDate: [""],
      EndDate: [""],
      BusinessStreamId: [""],
      AccountManager: [""],
      CategoryId: [""],
      Mobile: [""],
      Landline: [""],
      CountryId: [""],
      PaymentHistoryId: [""],
      FinancialStatusId: [""],
      SupplierDeliveryHistoryId: [""],
      KeyAccounts: [""],
      ClientTime: [""],
      StateId: [""],
      CityId: [""],
      MapLocation: [""],
      Fax: [""],
      Email: [""],
      Website: [""],
      AddressLine1: [""],
      AddressLine2: [""],
      AddressLine3: [""],
      PostalCode: [""],
      Remarks: [""],
      Status: [""],
    });

    let data = {
      CompanyName: "",
      CompanyType: "",
      StartDate: "",
      EndDate: "",
      BusinessStream: "",
      Category: "",
      CompanyProfile: "",
      Country: "",
      State: "",
      City: "",
      AccountManager: "",
      KeyAccount: "",
      ParentCompany: "",
      Status: "",
      SearchWord: this.searchword,
      Sort: "",
      SortWise: "",
      Export: "false",
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
    };
    this.spinner.show();
    this.UserService.CompanyListFilter(data).subscribe((response: any) => {
      if (response["result"] == "success") {
        this.spinner.hide();
        this.currentPage = 0;
        this.showcompany = response["UserList"];
        this.dataSource = new MatTableDataSource<any>(response["UserList"]);
        this.dataSource.paginator = this.paginator;
        this.TotalRecord = response["TotalRecord"];
        this.totalSize = response["TotalRecord"];
        this.iterator();
      }
      this.resetPagination = true;
    });

    this.getCountries();
    this.getbusiness();
    this.getname();
    this.gettype();
    this.getcategory();
    this.getProfile();
    this.getAccount();
    this.getParent();
  }

  get f() {
    return this.editUserForm.controls;
  }

  selectedItems5: any = [];
  selectedStatus: string = "";
  selectedStatusId: string = "";
  onStatusSelect(item: any) {
    this.selectedStatus = "";
    this.selectedStatusId = "";
    this.selectedItems5.forEach((element) => {
      this.selectedStatus += element["itemName"] + ", ";
      this.selectedStatusId += element["id"] + ", ";
    });
  }

  getbusiness() {
    let data = {};
    this.businessStream = [];
    this.UserService.GetBusinessStream(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.businessStreamArray = res;
        for (const item of this.businessStreamArray["Data"]) {
          this.businessStream.push({
            id: item["BSID"],
            itemName: item["BusinessStream"],
          });
        }
      } else {
        this.businessStreamArray = [];
      }
    });
  }
  selectedBusiness: any = [];
  selectedBusinessName: string = "";
  selectedBusinessNameId: string = "";
  onBusinessSelect(item: any) {
    this.selectedBusinessName = "";
    this.selectedBusinessNameId = "";
    this.selectedBusiness.forEach((element) => {
      this.selectedBusinessName += element["itemName"] + ", ";
      this.selectedBusinessNameId += element["id"] + ", ";
    });
  }

  getname() {
    let data = {};
    this.showname = [];
    this.UserService.GetAllCompanyName(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.shownameArray = res;
        for (const item of this.shownameArray["Data"]) {
          this.showname.push({
            id: item["CompanyId"],
            itemName: item["CompanyName"],
          });
        }
      } else {
        this.shownameArray = [];
      }
    });
  }

  selectedname: any = [];
  selectedName: string = "";
  selectedNameId: string = "";
  onNameSelect(item: any) {
    this.selectedName = "";
    this.selectedNameId = "";
    this.selectedname.forEach((element) => {
      this.selectedName += element["itemName"] + ", ";
      this.selectedNameId += element["id"] + ", ";
    });
  }

  gettype() {
    let data = {};
    this.showtype = [];
    this.UserService.getcompanytype(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showntypeArray = res;
        for (const item of this.showntypeArray["Data"]) {
          this.showtype.push({
            id: item["Id"],
            itemName: item["CompanyType"],
          });
        }
      } else {
        this.showntypeArray = [];
      }
    });
  }
  selectedtype: any = [];
  selectedType: string = "";
  selectedTypeId: string = "";
  onTypeSelect(item: any) {
    this.selectedType = "";
    this.selectedTypeId = "";
    this.selectedtype.forEach((element) => {
      this.selectedType += element["itemName"] + ", ";
      this.selectedTypeId += element["id"] + ", ";
    });
  }

  getcategory() {
    let data = {};
    this.showcategory = [];
    this.UserService.GetCategory(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showcategoryArray = res;
        for (const item of this.showcategoryArray["Data"]) {
          this.showcategory.push({
            id: item["CategoryID"],
            itemName: item["CategoryDescription"],
          });
        }
      } else {
        this.showcategoryArray = [];
      }
    });
  }
  selectedcategory: any = [];
  selectedCategory: string = "";
  selectedCategoryId: string = "";
  onCategorySelect(item: any) {
    this.selectedCategory = "";
    this.selectedCategoryId = "";
    this.selectedcategory.forEach((element) => {
      this.selectedCategory += element["itemName"] + ", ";
      this.selectedCategoryId += element["id"] + ", ";
    });
  }

  getProfile() {
    let data = {};
    this.showstatus = [];
    this.UserService.GetCompanyProfile(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showProfileArray = res;
        for (const item of this.showProfileArray["Data"]) {
          this.showstatus.push({
            id: item["CompanyProfileId"],
            itemName: item["Name"],
          });
        }
      } else {
        this.showProfileArray = [];
      }
    });
  }
  selectedprofile: any = [];
  selectedProfile: string = "";
  selectedProfileId: string = "";
  onProfileSelect(item: any) {
    this.selectedProfile = "";
    this.selectedProfileId = "";
    this.selectedprofile.forEach((element) => {
      this.selectedProfile += element["itemName"] + ", ";
      this.selectedProfileId += element["id"] + ", ";
    });
  }

  getAccount() {
    let data = {};
    this.showaccount = [];
    this.UserService.GetAccountManager(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showAccountArray = res;
        for (const item of this.showAccountArray["Data"]) {
          this.showaccount.push({
            id: item["UserId"],
            itemName: item["UserName"],
          });
        }
      } else {
        this.showAccountArray = [];
      }
    });
  }
  selectedaccount: any = [];
  selectedAccount: string = "";
  selectedAccountId: string = "";
  onAccountSelect(item: any) {
    this.selectedAccount = "";
    this.selectedAccountId = "";
    this.selectedaccount.forEach((element) => {
      this.selectedAccount += element["itemName"] + ", ";
      this.selectedAccountId += element["id"] + ", ";
    });
  }

  getParent() {
    let data = {};
    this.showparent = [];
    this.UserService.GetAllCompanyName(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showParentArray = res;
        for (const item of this.showParentArray["Data"]) {
          this.showparent.push({
            id: item["CompanyId"],
            itemName: item["CompanyName"],
          });
        }
      } else {
        this.showParentArray = [];
      }
    });
  }
  selectedparent: any = [];
  selectedParent: string = "";
  selectedParentId: string = "";
  onParentSelect(item: any) {
    this.selectedParent = "";
    this.selectedParentId = "";
    this.selectedparent.forEach((element) => {
      this.selectedParent += element["itemName"] + ", ";
      this.selectedParentId += element["id"] + ", ";
    });
  }

  getCountries() {
    let data = {};
    this.CountryList = [];
    this.UserService.GetCountries(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.countryListArray = res;
        this.shortcountryname = res["Data"];
        this.shortname = res["Data"]["iso2"];
        for (const item of this.countryListArray["Data"]) {
          this.CountryList.push({
            id: item["Id"],
            itemName: item["Name"],
            shortname: item["iso2"],
          });
        }
      } else {
        this.countryListArray = [];
      }
    });
  }
  selectedCountryName: string = "";
  selectedCountryId: string = "";
  selectedCountry: any = [];
  selectedId: string = "";
  onCountrySelect(item: any) {
    this.selectedCountryName = "";
    this.selectedCountryId = "";
    this.selectedCountry.forEach((element) => {
      this.selectedCountryName += element["itemName"] + ", ";
      this.selectedCountryId += element["id"] + ",";
    });
    this.selectedId = this.selectedCountryId.slice(0, -1);
    this.stateList = [];
    this.selectedState = [];
    this.cityList = [];
    this.selectedCity = [];
    this.getStatesByCountryId(this.selectedId);
  }
  stateArray: any = [];

  getStatesByCountryId(id) {
    let data = {
      CountryId: id,
    };
    this.UserService.GetStatesByCountryId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.stateArray = res;
        for (const item of this.stateArray["Data"]) {
          this.stateList.push({
            id: item["Id"],
            itemName: item["Name"],
          });
        }
      } else {
        this.stateList = [];
      }
    });
  }
  stateList: any = [];
  selectedStateName: string = "";
  selectedStateId: string = "";
  selectedState: any = [];
  onStateSelect(item: any) {
    this.selectedStateName = "";
    this.selectedStateId = "";
    this.selectedState.forEach((element) => {
      this.selectedStateName = element["itemName"];
      this.selectedStateId = element["id"];
    });
    this.cityList = [];
    this.selectedCity = [];
    this.getCitiesByStateId(this.selectedStateId);
  }
  getCitiesByStateId(id) {
    let data = {
      StateId: id,
    };
    this.UserService.GetCitiesByStateId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.cityArray = res;
        for (const item of this.cityArray["Data"]) {
          this.cityList.push({
            id: item["Id"],
            itemName: item["Name"],
          });
        }
      } else {
        this.cityList = [];
      }
    });
  }
  selectedCityName: string = "";
  selectedCityId: string = "";
  selectedCity: any = [];
  onCitySelect(item: any) {
    this.selectedCityName = "";
    this.selectedCityId = "";
    this.selectedCity.forEach((element) => {
      this.selectedCityName = element["itemName"];
      this.selectedCityId = element["id"];
    });
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (
      this.fromDate &&
      !this.toDate &&
      date &&
      date.after(this.fromDate)
    ) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  dateChangeFun() {
    if (this.date_range && this.date_range != undefined) {
      if (this.date_range.startDate != null) {
        this.start_date = this.datePipe.transform(
          this.date_range.startDate.tz(this.timezone)._d,
          "yyyy-MM-dd"
        );
        this.end_date = this.datePipe.transform(
          this.date_range.endDate.tz(this.timezone)._d,
          "yyyy-MM-dd"
        );
        this.start_date = moment(this.start_date, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        );
        this.end_date = moment(this.end_date, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        );
      } else {
        this.start_date = "";
      }
    }
  }

  onItemSelect(item: any) {}
  onSelectAll(items: any) {}
  onDeSelectAll(items: any) {}

  tr: any;
  date: any;
  onSubmit() {
    this.currentPage = 0;
    this.showTable = false;
    let start;
    let end;
    this.spinner.show();
    if (
      this.date_range.startDate &&
      this.date_range.startDate != "" &&
      this.date_range.endDate &&
      this.date_range.endDate != ""
    ) {
      start = this.datePipe.transform(this.date_range.startDate, "yyyy-MM-dd");
      end = this.datePipe.transform(this.date_range.endDate, "yyyy-MM-dd");
    } else {
      start = "";
      end = "";
    }
    this.date = Array.prototype.map
      .call(this.selectedItemsdate, function (item2) {
        return item2.itemName;
      })
      .join(",");
    this.KeyAccounts = Array.prototype.map
      .call(this.selectedItems6, function (item) {
        return item.id;
      })
      .join(",");
    let data = {
      CompanyName: this.selectedNameId,
      CompanyType: this.selectedTypeId,
      StartDate: start,
      EndDate: end,
      BusinessStream: this.selectedBusinessNameId,
      Category: this.selectedCategoryId,
      CompanyProfile: this.selectedProfileId,
      Country: this.selectedCountryId,
      State: this.selectedStateId,
      City: this.selectedCityId,
      AccountManager: this.selectedAccountId,
      KeyAccount: this.KeyAccounts,
      ParentCompany: this.selectedParentId,
      Status: this.selectedStatusId,
      SearchWord: "",
      Sort: "",
      SortWise: "",
      Export: "false",
      ItemPerPages: "",
      PageNo: "",
    };
    this.spinner.show();
    this.UserService.CompanyListFilter(data).subscribe(
      (res) => {
        if (res["result"] == "success") {
          this.spinner.hide();
          this.showTable = true;
          this.showcompany = res["UserList"];
          this.dataSource = new MatTableDataSource<any>(res["UserList"]);
          this.TotalRecord = res["TotalRecord"];
          this.tr = res["TotalRecord"];
          this.totalSize = this.TotalRecord;
          this.router.navigate(["/company/company-list"]);
        } else if (res["result"] == "Failed") {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(res["Message"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
      }
    );
  }

  resetData() {
    this.selectedNameId = "";
    this.selectedTypeId = "";
    this.selectedBusinessNameId = "";
    this.selectedCategoryId = "";
    this.selectedProfileId = "";
    this.selectedAccountId = "";
    this.selectedParentId = "";
    this.selectedStateId = "";
    this.selectedCityId = "";
    this.selectedCountryId = "";
    this.KeyAccounts = "";
    this.selectedStatusId = "";
    this.selectedselect_date = [];
    this.selecteddate_range = [];
    this.registerForm.reset();
    this.totalSize = this.tr;
    this.ngOnInit();
    this.isCollapsed = true;
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  openClosefun() {
    this.isCollapsed = !this.isCollapsed;
  }

  openClosefun1() {
    this.isCollapsed1 = !this.isCollapsed1;
  }

  ExportOpenModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: "modal-sm modal-dialog-centered",
    });
  }

  exportConfirm() {
    this.exportcompany();
    this.modalRef.hide();
  }

  exportcompany() {
    let start;
    let end;
    this.spinner.show();
    if (
      this.date_range.startDate &&
      this.date_range.startDate != "" &&
      this.date_range.endDate &&
      this.date_range.endDate != ""
    ) {
      start = this.datePipe.transform(this.date_range.startDate, "yyyy-MM-dd");
      end = this.datePipe.transform(this.date_range.endDate, "yyyy-MM-dd");
    } else {
      start = "";
      end = "";
    }
    let data = {
      SearchWord: this.searchword,
      CompanyName: this.selectedNameId,
      CompanyType: this.selectedTypeId,
      StartDate: start,
      EndDate: end,
      BusinessStream: this.selectedBusinessNameId,
      Category: this.selectedCategoryId,
      CompanyProfile: this.selectedProfileId,
      Country: this.selectedCountryId,
      State: this.selectedStateId,
      City: this.selectedCityId,
      AccountManager: this.selectedAccountId,
      KeyAccount: this.KeyAccounts,
      ParentCompany: this.selectedParentId,
      Status: this.selectedStatusId,
      PageNo: this.currentPage + 1,
      Sort: this.namesort,
      SortWise: this.type,
      Export: "true",
      ItemPerPages: this.pageSize,
    };
    this.UserService.CompanyListFilter(data).subscribe((res: any) => {
      if (res["result"] == "success") {
        this.spinner.hide();
        let exporturl = res["Data"];
        window.open(this.baseurl + "/" + exporturl);
      }
    });
  }
  //exportend

  //import//
  onChange(evt) {
    const target: DataTransfer = <DataTransfer>evt.target;
    this.isExcelFile = !!/\.xls|\.xlsx/.exec(target.files[0].name);
    if (!this.isExcelFile) {
      this.toastr.error("Invaild File Format. Only xlsx Files Are Allowed !");
      return;
    }
    this.upfile = target.files[0];
    if (target.files.length > 1) {
      this.inputFile.nativeElement.value = "";
    }
    if (this.isExcelFile) {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        let arrHeaderMain = wb["Sheets"][wsname];
        this.arrHeader = [];
        if (arrHeaderMain == undefined || arrHeaderMain == null) {
          this.count = 0;
        } else {
          this.arrHeader.push(arrHeaderMain.A1?.h);
          this.arrHeader.push(arrHeaderMain.B1?.h);
          this.arrHeader.push(arrHeaderMain.C1?.h);
          this.arrHeader.push(arrHeaderMain.D1?.h);
          this.arrHeader.push(arrHeaderMain.E1?.h);
          this.arrHeader.push(arrHeaderMain.F1?.h);
          this.arrHeader.push(arrHeaderMain.G1?.h);
          this.arrHeader.push(arrHeaderMain.H1?.h);
          this.arrHeader.push(arrHeaderMain.I1?.h);
          this.arrHeader.push(arrHeaderMain.J1?.h);
          this.arrHeader.push(arrHeaderMain.K1?.h);
          this.arrHeader.push(arrHeaderMain.L1?.h);
          this.arrHeader.push(arrHeaderMain.M1?.h);
          this.arrHeader.push(arrHeaderMain.N1?.h);
          this.arrHeader.push(arrHeaderMain.O1?.h);
          this.arrHeader.push(arrHeaderMain.P1?.h);
          this.arrHeader.push(arrHeaderMain.Q1?.h);
          this.arrHeader.push(arrHeaderMain.R1?.h);
          this.arrHeader.push(arrHeaderMain.S1?.h);
          this.arrHeader.push(arrHeaderMain.T1?.h);
          this.arrHeader.push(arrHeaderMain.U1?.h);
          this.arrHeader.push(arrHeaderMain.V1?.h);
          this.arrHeader.push(arrHeaderMain.W1?.h);
          this.arrHeader.push(arrHeaderMain.X1?.h);
          this.arrHeader.push(arrHeaderMain.Y1?.h);
        }

        /* save data */
        this.data = XLSX.utils.sheet_to_json(ws, { raw: true });
      };

      reader.readAsBinaryString(target.files[0]);

      reader.onloadend = (e) => {
        this.showcompany = Object.keys(this.data);
        this.dataSheet.next(this.data);
        this.count = 0;
        let arr = [
          "CompanyName",
          "ParentCompany",
          "CompanyType",
          "CompanyProfile",
          "BusinessStream",
          "AccountManager",
          "Category",
          "PaymentHistory",
          "FinancialStatus",
          "SupplierDeliveryHistory",
          "KeyAccounts",
          "ClientTime",
          "Country",
          "State",
          "City",
          "MapLocation",
          "Landline",
          "Mobile",
          "Fax",
          "Email",
          "Website",
          "AddressLine1",
          "AddressLine2",
          "PostalCode",
          "Remarks",
        ];

        if (
          JSON.stringify(this.arrHeader) === JSON.stringify(arr) &&
          this.arrHeader.length > 0
        ) {
          if (this.showcompany.length > 0) {
            if (this.showcompany.length <= 1000) {
              this.count = 2;
            } else {
              this.count = 3;
            }
          } else {
            this.count = 1;
          }
        } else {
          this.count = 0;
        }
      };
    } else {
      this.inputFile.nativeElement.value = "";
    }
  }

  import() {
    if (this.data == undefined) {
      this.toastr.error("Please Select a valid xlsx file");
      return null;
    } else if (this.count == 0) {
      this.toastr.error("Invalid Template!");
      return;
    } else if (this.count == 1) {
      this.toastr.error("File should not be empty !");
      return;
    } else if (this.count == 3) {
      this.toastr.error("Maximum 1000 records are allowed !");
      return;
    } else {
      this.spinner.show();
      this.UserService.Importcompany(this.data).subscribe((res) => {
        if (res["result"] == "success") {
          this.spinner.hide();
          this.showimport.nativeElement.click();
          this.Totalrec = res["TotalRecord"];
          this.invalid = res["InvaildRow"];
          this.valid = this.Totalrec - this.invalid;
          this.dataarray = res["Data"];
          this.toastr.success(res["Msg"]);
        } else if (res["result"] == "Failed") {
          this.spinner.hide();
          this.showimport.nativeElement.click();
          this.Totalrec = res["TotalRecord"];
          this.invalid = res["InvaildRow"];
          this.valid = this.Totalrec - this.invalid;
          this.dataarray = res["Data"];
        } else {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        }
      });
    }
  }

  rtnView() {
    this.router
      .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
      .then(() => {
        this.router.navigateByUrl("/company/company-list");
      });
  }

  countrychange(event) {
    let name = event.target.value;
    this.shortcountryname.forEach((element) => {
      if (name == element.Id) {
        this.shortcountrynam = element.iso2;
      }
    });
  }
  onCountrySelectshort(item: any) {
    this.selectedCountryName = "";
    this.selectedCountryId = "";
    this.CountryList.forEach((element) => {
      let cid = this.selectedCountry[0].id;
      if (cid == element.id) {
        this.shortcountrynam = this.selectedCountry[0].shortname;
      }
    });
  }

  companyname(data) {
    this.selectedCountry = [];
    this.comname = data.CompanyName;
    this.comid = data.CompanyId;
    this.selectedCountry.push({
      id: data.CountryId,
      itemName: data.CountryName,
    });
    let name = data.CountryId;
    this.shortcountryname.forEach((element) => {
      if (name == element.Id) {
        this.shortcountrynam = element.iso2;
      }
    });
  }

  saveprefix() {
    this.submitted = true;
    let cur = this.shortcountrynam;
    let shortpre = this.editUserForm.value.Prefix;
    let finalpre = cur + "" + shortpre;

    if (this.editUserForm.valid) {
      let data = {
        CompanyId: this.comid,
        shortcountry: this.editUserForm.value.shortcountry,
        Prefix: finalpre,
        CountryId: this.selectedCountryId,
      };
      if (this.editUserForm.valid) {
        this.spinner.show();
        this.UserService.SetCompanyPrefix(data).subscribe((res) => {
          if (res["result"] == "success") {
            this.spinner.hide();
            this.toastr.success(res["Msg"]);
            this.router
              .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
              .then(() => {
                this.router.navigateByUrl("/company/company-list");
              });
          } else if (res["result"] == "Failed") {
            this.toastr.error(res["Msg"]);
            this.spinner.hide();
          }
        });
      } else {
        alert("Error");
      }
    }
  }

  public handlePage(e: any) {
    let start;
    let end;
    this.spinner.show();
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;

    if (
      this.date_range.startDate &&
      this.date_range.startDate != "" &&
      this.date_range.endDate &&
      this.date_range.endDate != ""
    ) {
      start = this.datePipe.transform(this.date_range.startDate, "yyyy-MM-dd");
      end = this.datePipe.transform(this.date_range.endDate, "yyyy-MM-dd");
    } else {
      start = "";
      end = "";
    }

    this.iterator();
    let data = {
      CompanyName: this.selectedNameId,
      CompanyType: this.selectedTypeId,
      StartDate: start,
      EndDate: end,
      BusinessStream: this.selectedBusinessNameId,
      Category: this.selectedCategoryId,
      CompanyProfile: this.selectedProfileId,
      Country: this.selectedCountryId,
      State: this.selectedStateId,
      City: this.selectedCityId,
      AccountManager: this.selectedAccountId,
      KeyAccount: this.KeyAccounts,
      ParentCompany: this.selectedParentId,
      Status: this.selectedStatusId,
      SearchWord: this.searchword,
      Sort: this.namesort,
      SortWise: this.type,
      Export: "false",
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
    };
    this.UserService.CompanyListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["UserList"]);
      }
    });
  }

  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.showcompany.slice(start, end);
    this.dataSource = part;
  }

  onSortData(sort: Sort) {
    let start, end;
    this.currentPage = 0;
    this.spinner.show();
    this.changeDetectorRefs.detectChanges();
    this.sortData = [];
    this.sortData = { column: sort.active, direction: sort.direction };
    this.type = sort.direction;
    this.namesort = sort.active;
    if (sort.direction == "asc") {
      this.upicon = true;
      this.downicon = false;
    } else {
      this.upicon = false;
      this.downicon = true;
    }
    this.columnsort = sort.active;
    if (
      this.date_range.startDate &&
      this.date_range.startDate != "" &&
      this.date_range.endDate &&
      this.date_range.endDate != ""
    ) {
      start = this.datePipe.transform(this.date_range.startDate, "yyyy-MM-dd");
      end = this.datePipe.transform(this.date_range.endDate, "yyyy-MM-dd");
    } else {
      start = "";
      end = "";
    }
    let data = {
      SearchWord: this.searchword,
      CompanyName: this.selectedNameId,
      CompanyType: this.selectedTypeId,
      StartDate: start,
      EndDate: end,
      BusinessStream: this.selectedBusinessNameId,
      Category: this.selectedCategoryId,
      CompanyProfile: this.selectedProfileId,
      Country: this.selectedCountryId,
      State: this.selectedStateId,
      City: this.selectedCityId,
      AccountManager: this.selectedAccountId,
      KeyAccount: this.KeyAccounts,
      ParentCompany: this.selectedParentId,
      Status: this.selectedStatusId,
      PageNo: this.currentPage + 1,
      Sort: sort.active,
      SortWise: sort.direction,
      Export: "",
      ItemPerPages: this.pageSize,
    };
    this.dataSource = [];
    this.UserService.CompanyListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["UserList"]);
      }
    });
  }

  modeldisplay3: any = false;
  applyback: any;
  name: string;
  openStatusModel(
    template: TemplateRef<any>,
    UserID: any,
    state: any,
    data: any
  ) {
    this.status_id = UserID;
    this.sta_type = state;
    this.name = data.CompanyName;
    this.CmpStatus = data.StatusName;
    this.modeldisplay3 = true;
    this.applyback = true;
    this.modalRef = this.modalService.show(template, {
      class: "modal-md modal-dialog-centered",
    });
  }

  hidemodel2() {
    this.modeldisplay3 = false;
  }

  makeActiveInactive() {
    this.submitted1 = true;
    if (this.StatusForm.valid) {
      const data = {
        CompanyId: this.status_id,
        Status: this.sta_type,
        StatusRemark: this.StatusForm.value.Remark,
      };
      this.spinner.show();
      this.UserService.makeActiveInactived(data).subscribe(
        (res: any) => {
          if (res["result"] == "success") {
            this.spinner.hide();
            this.toastr.success(res["Msg"], "Success!");
            this.modalRef.hide();
            this.modeldisplay3 = false;
            this.router
              .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
              .then(() => {
                this.router.navigateByUrl("/company/company-list");
              });
          } else {
            this.err_message = res.Msg;
            this.spinner.hide();
          }
        },
        (err: any) => {
          this.spinner.hide();
        }
      );
      this.submitted1 = false;
    }
  }

  deleteOpenModal(template: TemplateRef<any>, name, data) {
    if (data) {
      this.deleteId = data;
      this.file = name;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  decline() {
    this.modalRef.hide();
  }

  clear() {
    this.StatusForm.get("Remark").patchValue("");
  }

  deleteConfirm() {
    this.deletecompany();
    this.modalRef.hide();
  }

  deletecompany() {
    this.spinner.show();
    this.UserService.DeleteCompany({ CompanyId: this.deleteId }).subscribe(
      (response: any) => {
        if (response["result"] == "success") {
          this.spinner.hide();
          this.toastr.success("Company Deleted Successfully!");
          this.ngOnInit();
        } else {
          this.err_message = response.Msg;
        }
      }
    );
  }

  view(eid) {
    if (this.permission.Company_View == 1 || this.roleId == 1) {
      let encryptid = this.UserService.encryptData(eid);
      encryptid = encryptid
        .toString()
        .replace("=", "Ar1t")
        .replace("/", "FGH")
        .replace("+", "THD");
      this.router.navigate(["/company/detailcompany", encryptid]);
    } else {
      this.toastr.error("Permission Denied !");
    }
  }

  edit(id) {
    let encryptid = this.UserService.encryptData(id);
    this.router.navigate(["/company/editcompany", encryptid]);
  }

  clearEndDate() {
    this.date_range = null;
  }

  //websitenewsite
  website(web) {
    let weblink = web;
    window.open(weblink);
  }

  AddHttpfun(value) {
    if (value) {
      if (value.startsWith("http") || value.startsWith("https")) {
        let b = value;
        window.open(b);
      } else {
        let a = "http://" + value;
        window.open(a);
      }
    }
  }

  //restore
  restoreOpenModal(template: TemplateRef<any>, data) {
    if (data) {
      this.restoreId = data.CompanyId;
      this.file = data.CompanyName;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  restoreConfirm() {
    this.restorecompany();
    this.modalRef.hide();
  }

  restorecompany() {
    this.spinner.show();
    this.UserService.RestoreCompany({ CompanyId: this.restoreId }).subscribe(
      (response: any) => {
        if (response["result"] == "success") {
          this.spinner.hide();
          this.toastr.success("Company Restore Successfully!");
          this.router
            .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
            .then(() => {
              this.router.navigateByUrl("/company/company-list");
              this.ngOnInit();
            });
        } else {
          this.err_message = response.Msg;
        }
      }
    );
  }

  applyFilter() {
    this.currentPage = 0;
    this.spinner.show();
    let data = {
      SearchWord: this.searchword,
      CompanyName: this.selectedNameId,
      CompanyType: this.selectedTypeId,
      StartDate: "",
      EndDate: "",
      BusinessStream: this.selectedBusinessNameId,
      Category: this.selectedCategoryId,
      CompanyProfile: this.selectedProfileId,
      Country: this.selectedCountryId,
      State: this.selectedStateId,
      City: this.selectedCityId,
      AccountManager: this.selectedAccountId,
      KeyAccount: this.KeyAccounts,
      ParentCompany: this.selectedParentId,
      Status: this.selectedStatusId,
      PageNo: this.currentPage + 1,
      Sort: "",
      SortWise: "",
      Export: "",
      ItemPerPages: this.pageSize,
    };
    this.UserService.CompanyListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["UserList"]);
      }
    });
  }

  clearUserData() {
    const previousValue = this.searchword;
    this.searchword = "";
    if (
      previousValue &&
      previousValue.length > 0 &&
      previousValue !== this.searchword
    ) {
      this.clearEvent.emit();
    }
  }

  NameSpaceNotAllowed(event: any) {
    let RegEx = /^([a-zA-Z\d!@#$&().,%*=|~[\]{}<>?'";:-])*$/g;
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      let nameString = str.replace(/\s+/g, " ");
      nameString = nameString.replace(
        /[^a-zA-Z\d!@#$&()\-`.+,%*-=|~[\]{}/<>'";:]+/g,
        " "
      );
      event.target.value = nameString.replace(/^\s+/g, "");
    }
  }
}
